import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'
import UseTranslation from '../../../../hooks/UseTranslation'

function StepOne({ count }) {
  const { t } = UseTranslation()
  return (
        <Box sx={styles.root}>
            <Typography sx={{ fontWeight: 'normal' }}>
               {t?.['You are going to create users for all non - registered employees in your company.']}
            </Typography>
            <Typography>
                {t?.['Your company is currently having']}  <Typography component={'span'} sx={styles.count}> {count} </Typography> {t?.['Employees without Users.']}
            </Typography>
            <Typography> {t?.['Do you want to proceed ?']} </Typography>
        </Box>
  )
}
const styles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    p: { xs: '10px 5px 0px ', sm: '20px' },
  },
  count: { color: '#29CC8B', fontWeight: 'bold' },
}

export default StepOne
